import React, { Component } from 'react';
import RavenCard from '../../account/ravenCard';
import { strings } from 'APP_ROOT/localization';
import BillingAndPaymentsSection from '../../account/BillingAndPaymentsSection';

export default class MobileBillingPage extends Component {

    showBillingDetails() {
        if(!this.props.features?.show_billing) return false;
        if(!this.props.accountDetails?.grantedPermissions) return false;
        if(!Array.isArray(this.props.accountDetails.grantedPermissions)) return false;

        return this.props.accountDetails.grantedPermissions.includes("account:ReadBilling");
    }

    canEditBilling() {
        return this.props.accountDetails.grantedPermissions.includes("account:WriteBilling");
    }

    render() {
        if (!this.props.ravens) return null;

        return (
            <div className="account-page mobile-billing-page container">
                <div className="row">
                    <div className="col-12">
                        <h2>{strings.raven_subscription_service_plans_title}</h2>
                    </div>
                    {this.props.ravens.map((raven, i) => {
                        if (!raven.canEdit) return null
                        return (
                            <RavenCard
                                key={i}
                                raven={raven}
                                {...this.props}
                                mobileVersion={true} />
                        )
                    })}
                </div>
                {this.showBillingDetails() && <BillingAndPaymentsSection {...this.props} canEditBilling={this.canEditBilling()} />}
            </div>
        )
    }
}
